import { TranslateService } from "@ngx-translate/core";

/**
 * Meldung des CMS anzeigen, wenn es eine gibt — sonst den allgemeinen Text.
 * ⚠ Ohne das bleibt bei einem Serverfehler der Bildschirm stumm.
 */
export function voucherErrorMessage(
  error: any,
  fallbackKey: string,
  translate: TranslateService,
): string {
  const message = error?.error?.message ?? error?.message;

  return typeof message === "string" && message.length > 0
    ? message
    : translate.instant(fallbackKey);
}
